import { useContext } from "react";
import { AuthContext } from "../contexts/AuthContext";
import { userService } from "../services/userService";


export const useUser = () => {
  const { user, setUser, clearAuth } = useContext(AuthContext);

  const addUser = (user) => {
    setUser(user);
  };

  const removeUser = () => {
    clearAuth();
  };

  const logout = async () => {
    try {
      await userService.logout();
      removeUser();
    } catch (error) {
      console.error('Logout failed:', error);
      throw error;
    }
  };

  return { user, addUser, removeUser, setUser, logout };
};